const CALLBACK_VALIDATION_ORIGIN = 'https://callback.invalid';
const ENCODED_LEADING_AUTHORITY_SEPARATOR = /^\/%(?:2f|5c)/i;

function containsUnsafeCallbackCharacter(value: string): boolean {
  for (const character of value) {
    const characterCode = character.charCodeAt(0);
    if (character === '\\' || characterCode <= 0x1f || characterCode === 0x7f) {
      return true;
    }
  }
  return false;
}

function hasUnsafeCallbackSyntax(value: string): boolean {
  return (
    containsUnsafeCallbackCharacter(value) ||
    ENCODED_LEADING_AUTHORITY_SEPARATOR.test(value)
  );
}

export function resolveSafeRelativeCallbackPath(
  value: string | null | undefined
): string | null {
  if (!value) return null;

  const trimmed = value.trim();
  if (
    !trimmed ||
    !trimmed.startsWith('/') ||
    trimmed.startsWith('//') ||
    hasUnsafeCallbackSyntax(trimmed)
  ) {
    return null;
  }

  try {
    const callbackUrl = new URL(trimmed, CALLBACK_VALIDATION_ORIGIN);
    if (callbackUrl.origin !== CALLBACK_VALIDATION_ORIGIN) {
      return null;
    }

    return `${callbackUrl.pathname}${callbackUrl.search}${callbackUrl.hash}`;
  } catch {
    return null;
  }
}

export function resolveSafeSameOriginCallbackUrl(params: {
  value: string | null | undefined;
  baseUrl: string;
}): string | null {
  const relativePath = resolveSafeRelativeCallbackPath(params.value);
  if (relativePath) {
    return relativePath;
  }
  if (!params.value) return null;

  const trimmed = params.value.trim();
  if (!trimmed || hasUnsafeCallbackSyntax(trimmed)) {
    return null;
  }

  try {
    const targetUrl = new URL(trimmed);
    const baseUrl = new URL(params.baseUrl);
    if (targetUrl.origin !== baseUrl.origin) {
      return null;
    }
    return targetUrl.toString();
  } catch {
    return null;
  }
}
